import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { auth } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";
import { isAdminEmail } from "./adminEmails";

export default function RequireAuth({ children }) {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => setUser(u || null));
    return () => unsub();
  }, []);

  if (user === undefined) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (!isAdminEmail(user.email)) return <Navigate to="/login" replace />;

  return children;
}
